import { useEffect, useState } from "react";

type PublicWelcomeScreenProps = {
  onLogin: () => void;
};

export default function PublicWelcomeScreen({ onLogin }: PublicWelcomeScreenProps) {
  const [videoAvailable, setVideoAvailable] = useState(true);
  const [showScrollCue, setShowScrollCue] = useState(true);

  useEffect(() => {
    const updateScrollCue = () => setShowScrollCue(window.scrollY < 160);
    updateScrollCue();
    window.addEventListener("scroll", updateScrollCue, { passive: true });
    return () => window.removeEventListener("scroll", updateScrollCue);
  }, []);

  return (
    <main className="public-home">
      <header className="public-header">
        <a className="public-brand" href="/" aria-label="Calm But Capable home">
          <img src="/logo-white.png" alt="" className="public-logo" />
          <span>Calm But Capable</span>
        </a>

        <button className="public-login" type="button" onClick={onLogin}>
          Login
        </button>
      </header>

      <section className="public-intro" aria-labelledby="welcome-heading">
        <p className="public-kicker">Understanding before judgement</p>
        <h1 id="welcome-heading">Welcome to Calm But Capable</h1>

        <div className="public-video-shell">
          {videoAvailable ? (
            <video
              className="public-video"
              autoPlay
              muted
              playsInline
              controls
              preload="metadata"
              poster="/welcome-cbc-poster.jpg"
              onError={() => setVideoAvailable(false)}
            >
              <source src="/welcome-cbc.mp4" type="video/mp4" />
              <track
                default
                kind="captions"
                src="/welcome-cbc.vtt"
                srcLang="en"
                label="English"
              />
            </video>
          ) : (
            <div className="public-video-placeholder">
              <span className="public-play-mark" aria-hidden="true">▶</span>
              <p>Your Calm But Capable welcome video will appear here.</p>
            </div>
          )}
        </div>
      </section>

      {showScrollCue && (
        <a
          className="public-scroll-cue"
          href="#route-heading"
          onClick={() => setShowScrollCue(false)}
        >
          <span>Choose your route</span>
          <span className="public-scroll-arrow" aria-hidden="true">↓</span>
        </a>
      )}

      <section className="public-routes" aria-labelledby="route-heading">
        <div className="public-routes-heading">
          <p className="public-kicker">Choose the route that is right for you</p>
          <h2 id="route-heading">What brings you here?</h2>
        </div>

        <div className="public-route-grid">
          <article className="public-route-card public-route-card--organisations">
            <p className="public-card-label">For teams and communities</p>
            <h3>Organisations and Education</h3>
            <p>
              Help students, staff or the people you support recognise their
              capability and take achievable steps towards progress.
            </p>
            <a className="public-route-link" href="/organisations">
              Discover how we can help <span aria-hidden="true">→</span>
            </a>
          </article>

          <article className="public-route-card public-route-card--individuals">
            <p className="public-card-label">For you</p>
            <h3>Individuals</h3>
            <p>
              Understand what is getting in your way and discover a personal,
              achievable way forward—without pressure or labels.
            </p>
            <a className="public-route-link" href="/individuals">
              Get the book for £5.99 delivered <span aria-hidden="true">→</span>
            </a>
          </article>
        </div>
      </section>

      <section className="public-belief">
        <p>
          People are often more capable than they appear—and more capable than
          they realise.
        </p>
      </section>
    </main>
  );
}
